export const COCKPIT_GAP = 8;

export const COCKPIT_BUBBLE_WRAPPER_STYLE = {
  default: {
    display: 'flex',
    alignItems: 'center'
  },
  '!small': {
    gap: COCKPIT_GAP
  }
};
